<template>
  <a href="#contato">Entre em contato</a>
</template>

<script>
export default {
  name: "CallToAction",
};
</script>

<style scoped>
a {
  color: var(--color-text-buttons);
  width: 200px;
  padding: 10px 0;
  background: var(--bg-buttons);
  text-align: center;
  font-size: var(--fs-text-buttons);
  font-family: "Segoe UI";
  margin-top: 2.5rem;
  display: block;
}
</style>
